<template>
   <div class='Terminadas'>
    
    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th scope="col">Solicitante</th>
                    <th scope="col">Pais</th>
                    <th scope="col">Fecha Adjudicado</th>
                    <th scope="col">Fecha Inicio</th>
                    <th scope="col">Fecha Entregado</th>
                    <th scope="col">Fecha Pagado</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Mi Evaluacion</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id_oferta" :class="f.reoferta == '1' ? 'table-warning' : ''">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}"> 
                            {{f.titulo_proyecto}}
                        </router-link>  
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-sm-2">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-sm-10">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>
                        <img :src="getBandera(f.pais_region)" class="bandera">
                    </td>
                    <td>{{fechaFormat(f.fecha_iniciop)}}</td>
                    <td>{{fechaFormat(f.fecha_iniciop)}}</td>
                    <td>{{fechaFormat(f.fecha_entrega)}}</td>
                    <td>{{fechaFormat(f.fecha_pago)}}</td>
                    <td>${{moneda(f.costo)}} <small>USD</small> </td>
                    <td>
                        <button class="btn btn-sm btn-primary" 
                                @click="preCarga(f)" 
                                data-toggle="modal"
                                data-target='#modalRating'
                                v-if="f.calificacionU == 0"
                        >
                            Calificar
                        </button>
                        <p v-else>
                            <star-rating :increment="0.1" :rating="makeNumber(f.calificacionU)" :star-size="20" :show-rating="true" :read-only="true"/>
                        </p>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
   

   <!--Modal Calificar -->
    <div class="modal fade" id="modalRating" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Califica a tu cliente: {{usuario}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="calificacion">
                <div class="modal-body">
                    
                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho estás con la <b>Fiabilidad</b> de tu cliente?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_f)" v-model="rating_f" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_f">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan comodo te sentiste con el nivel de <b>Conocimiento</b> mostrado por tu cliente sobre sus requerimientos?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_c)" v-model="rating_c" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_c">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Qué tan satisfecho estás con la <b>Empatia</b> mostrada hacia ti por tu cliente?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_e)" v-model="rating_e" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_e">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Cómo te sentiste con el nivel de <b>Seguridad</b> que manejo tu cliente?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_s)" v-model="rating_s" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_s">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho estás con la <b>Sensibilidad</b> con la que actuo tu cliente?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_ss)" v-model="rating_ss" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_ss">
                                ?
                            </button>
                        </div>
                    </div>
                    <hr>
                    
                    <p>Por favor de alguna sugerencia de mejora o comentario que pueda ayudar a tu Cliente obtener mayores beneficios en sus
                       proyectos y elevar su reputacion.</p>
                    <textarea class="form-control" v-model="resena" required placeholder="Comentarios...." rows="3" maxlength="280"></textarea>

                    <div class="row pt-2">
                        <div class="col-sm-8">
                            <h2> Calificacion: </h2> 
                        </div>
                        <div class="col-sm-4">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_total)" v-model="rating_total" :star-size="40" :show-rating="true" :read-only="true"/>
                        </div>
                    </div>   
                    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="submit" class="btn orange"> Aceptar </button>
                </div>
            </form>
            </div>
        </div>
    </div>


   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'
import $ from 'jquery'

export default {
name: 'Terminadas',
mixins: [ globalFunctions ],
components:{ StarRating },
data () {
    return {
        projectos: [],
        loading: true,
        rating: 0,
        resena: '',
        idSolicitante: '',
        idProyecto: '',
        usuario: '',
        rating_total: 0,
        rating_f: 0,
        rating_e: 0,
        rating_c: 0,
        rating_s: 0,
        rating_ss: 0,
        tooltip_f: 'Se refiere a la habilidad para solicitar de forma fiable y cuidadosa los servicios requeridos. Es decir, que el cliente cumple con sus compromisos, sobre entrega de elementos requeridos, suministro de información, explicación de problemas y fijación de objetivos.',
        tooltip_c: 'Capacidad para plantear necesidades válidas para su empresa y su entorno. Estas necesidades deben ser posibles, útiles, prácticas y concretas, con una clara justificacion de sus génesis y su factibilidad e idoneidad.',
        tooltip_e: 'Se refiere al nivel de atención y comunicacion individualizada que ofrece el Cliente a su Consultor. Se debe transmitir por medio de una disponibilidad de recursos requeridos para ejecutar el proyecto o servicio solicitado.',
        tooltip_s: 'Es el conocimiento y atención del Cliente y su habilidad para inspirar credibilidad, confianza, resguardar y proteger la información buscando mantener la confidencialidad, la disponibilidad e integridad de datos, sistemas y servicios recibidos.',
        tooltip_ss: 'Es la disposicion para ayudar y para prestarle una respuesta rápida y adecuada. Se refiere a la atención y prontitud al tratar las solicitudes, responder preguntas y aclaraciones, y solucionar problemas que estén dentro de su ámbito.'
    }
},
methods: {
    getData(){
        let data = {
            id: localStorage.userID,
            prop: 8,
            flag: 3
        };
    
        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false;
        });
    },
    
    preCarga(f){
        this.usuario = f.usuario;
        this.idSolicitante = f.id_user;
        this.idProyecto = f.id_proyecto;
    },
    
    sumar_cal(){
        let total = 0;
        total = this.rating_f + this.rating_c + this.rating_e + this.rating_s + this.rating_ss;
        total = total / 5;
        this.rating_total = total;
    },
    
    calificacion(e){
        e.preventDefault();

        if(this.rating_e == 0 || this.rating_c == 0 || this.rating_f == 0 || this.rating_s == 0 || this.rating_ss == 0 ){
            alert("Debe llenar todos los campos.");
            return;
        }
        
        let data = {
            quienEmp: localStorage.userID,
            rol: localStorage.rol,
            flag: 2,
            estrella: this.rating_total,
            resena: this.resena,
            quien: this.idSolicitante,
            idProyecto: this.idProyecto
        };
        
        this.axios.post(this.url + 'postProyectos.php',data).then((responce) =>{
            this.rating_total = 0;
            this.rating_e = 0;
            this.rating_c = 0;
            this.tooltip_f = 0;
            this.tooltip_s = 0;
            this.tooltip_ss = 0;
            this.resena = "";
            this.getData();
            $('#modalRating').modal('hide');
        });
    }
},
computed:{
    ...mapState(['url'])
},
watch:{
    rating_f(){
        this.sumar_cal();
    },
    rating_c(){
        this.sumar_cal();
    },
    rating_e(){
        this.sumar_cal();
    },
    rating_s(){
        this.sumar_cal();
    },
    rating_ss(){
        this.sumar_cal();
    }
},
mounted(){
    this.getData();

    $('#modalRating').on('shown.bs.modal', function (event) {
        $('[data-toggle="tooltip"]').tooltip();
    })
    
}
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/components/Consultor/Terminadas.vue